import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import { pageFadeIn } from "../../utils/animations";
import { data } from "../../utils/data.jsx";

const pages = data.pages;

const MobileMenu = ({ menuOpen, setMenuOpen }) => {
	return (
		<motion.div
			className='absolute md:hidden top-0 right-0 w-64 h-screen pl-8 py-28 backdrop-blur-3xl'
			variants={pageFadeIn}
			initial='hidden'
			animate='show'
			exit='exit'
			key={menuOpen}
			onClick={() => setMenuOpen(false)}
		>
			{pages.map((page) => (
				<div key={page.name} className='h-8 mb-[18px] relative flex items-center'>
					<NavLink to={page.to} className='flex gap-[10px]'>
						<p className='w-5 font-barlow font-bold text-16 leading-19 tracking-27 text-white'>
							{page.number}
						</p>
						<p className='font-barlow text-16 leading-19 tracking-27 text-white uppercase'>
							{page.name}
						</p>
					</NavLink>
					{page.to === window.location.pathname && (
						<div className='absolute w-1 h-8 right-0 bg-white' />
					)}
				</div>
			))}
		</motion.div>
	);
};

export default MobileMenu;
